import React from 'react';

import {DateCalendar} from '@mui/x-date-pickers/DateCalendar';

export default React.memo(DateCalendar);
